"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteSectionMutationOptions = exports.deleteSectionMutation = void 0;
const client_1 = require("@apollo/client");
const sectionsByCookbookId_1 = require("../queries/sectionsByCookbookId");
exports.deleteSectionMutation = client_1.gql `
  mutation DeleteSection($id: String!) {
    deleteSection(id: $id) {
      __typename
      ok
    }
  }
`;
exports.deleteSectionMutationOptions = (variables, cookbookId) => ({
    variables,
    update: store => {
        try {
            const data = store.readQuery({
                query: sectionsByCookbookId_1.sectionsByCookbookIdQuery,
                variables: { cookbookId },
            });
            if (data) {
                store.writeQuery({
                    query: sectionsByCookbookId_1.sectionsByCookbookIdQuery,
                    variables: { cookbookId },
                    data: {
                        __typename: "Query",
                        sectionsByCookbookId: data.sectionsByCookbookId.filter(x => x.id !== variables.id),
                    },
                });
            }
        }
        catch (_a) { }
    },
});
//# sourceMappingURL=deleteSection.js.map